import React, { ReactElement, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { RouteComponentProps, Route, Switch } from 'react-router-dom';
import { RouteLoadDurationProvider } from '@awsscm/argo-core/argo/utils/metrics/ArgoRouteLoadDurationContext';
import { Alert, Spinner, SpaceBetween } from '@amzn/awsui-components-react-v3';
import ViewContainer from './ViewContainer';
import ContainerHome from './ContainerHome';
import CreateContainer from './CreateContainer';
import { CMS_APP_CONFIG } from '../../services/container-management/queries';

/**
 * match.path from RouteComponentProps will have the current browser path
 */
export type ContainerManagementProps = RouteComponentProps;

/**
 * Component for Container Management Page
 * @component
 * @param {ContainerManagementProps} props
 */

const ContainerManagement = ({ match }: ContainerManagementProps): ReactElement => {
  const [cmsMaintenanceMode, setCmsMaintenanceMode] = React.useState<boolean>();

  // Query CMS feature flag API
  const [getCmsAppConfig, { loading: getCmsAppConfigLoading }] = useLazyQuery(CMS_APP_CONFIG, {
    fetchPolicy: 'network-only',
    onCompleted: (result) => {
      if (result?.getAppConfig?.value === 'true') {
        setCmsMaintenanceMode(false);
      } else {
        setCmsMaintenanceMode(true);
      }
    },
    onError: (error) => {
      setCmsMaintenanceMode(false);
    },
  });

  useEffect(() => {
    getCmsAppConfig({ variables: { name: 'CMSMaintenanceFlag', key: 'ALL0' } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (cmsMaintenanceMode === true) {
    return (
      <SpaceBetween direction="vertical" size="s">
        <Alert type="error">
          CMS is temporarily unavailable for maintenance, please follow #aws-globalcms-rollout
          channel for updates.
        </Alert>
      </SpaceBetween>
    );
  }
  return (
    <RouteLoadDurationProvider>
      {getCmsAppConfigLoading && <Spinner size="big" />}
      {!getCmsAppConfigLoading && (
        <Switch>
          <Route exact path={`${match.path}/`} component={ContainerHome} />
          <Route exact path={`${match.path}/create`} component={CreateContainer} />
          <Route exact path={`${match.path}/:containerId`} component={ViewContainer} />
        </Switch>
      )}
    </RouteLoadDurationProvider>
  );
};

export default ContainerManagement;
